"use client";

import type { Animation } from "@homeinstead/schemas";
import type { ReactNode } from "react";

import { motion, useReducedMotion } from "motion/react";
import { useStep } from "../LeadForm/FormBuilder/StepContext";
import { ANIMATION_VARIANTS, EASE_OUT } from "./animation-variants";

function AnimatedReveal({
  animation,
  children,
}: {
  animation?: Animation | null;
  children: ReactNode;
}) {
  const { isActive: isStepActive } = useStep();
  const prefersReducedMotion = useReducedMotion();

  if (!animation?.enabled || prefersReducedMotion) {
    return <>{children}</>;
  }

  const variant = ANIMATION_VARIANTS[animation.variant ?? "fade-left"];
  const durationSeconds = (animation.duration ?? 500) / 1000;
  const delaySeconds = (animation.delay ?? 0) / 1000;

  return (
    <motion.div
      animate={isStepActive ? "visible" : "hidden"}
      initial="hidden"
      variants={{
        hidden: {
          ...variant.initial,
          transition: { duration: 0 },
        },
        visible: {
          ...variant.animate,
          transition: {
            delay: delaySeconds,
            duration: durationSeconds,
            ease: EASE_OUT,
          },
        },
      }}
    >
      {children}
    </motion.div>
  );
}

export { AnimatedReveal };
